

<section>
  <div class="d-flex justify-content-between px-5 mt-4">
   
    
  </div>
  
    <div class="container-fluid px-5 mt-5">
      <div class="col-12 d-flex justify-content-between ">
        <div>
          <h4 class="text-white h2 my-4 ">Listado de proyectos</h4>
        </div>
        <br>
        <div class="d-flex justify-content-center align-items-center">
          <button
            class="badge rounded-pill btn btn-outline-light me-3"
            [routerLink]="['./../list']"
          >
            <i
              class="fa-solid fa-right-from-bracket m-2 fs-6"
              aria-hidden="true"
            ></i>
            <span class="m-2 fs-6">Volver al listado</span>
          </button>
          <button
          class="badge rounded-pill btn btn-outline-light m-1 "
          [routerLink]="['./../create/null/1']"
        >
        <i class="fa-solid fa-plus m-2 fs-6"></i>
        <span class="m-2 fs-6">Agregar</span>
        </button>
    
         
    
      
    
        </div>
      </div>
      <div class="backgroundTable">
        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="componente-importantes componente-importantes-from-popup">
          
          <ng-container *ngIf="creatingList.length == 0">">
            <div class="text-center text-white">
              <h2 class="text-white px-5 mt-5">Sin Registro</h2>
              <i class="fa-solid fa-face-sad-cry fa-5x my-3"></i>
            </div>
          </ng-container>

          <ng-container *ngIf="creatingList.length != 0">
          <thead>
            <tr>
              <th class="text-white text-center">Nombre</th>
              <th class="text-white text-center">Etapa</th>
              <th class="text-white text-center">Nombre Etapa</th>
              <th class="text-white text-center">Fecha inicio</th>
              <th class="text-white text-center">Fecha termino</th>
              <th class="text-white text-center">Opciones</th>
          </thead>

          <tbody>
            <tr *ngFor="let item of creatingList">

              <td class="text-center" >{{item.name}}</td>
              <td class="text-center">
                <span
                  style="width:4rem !important ;"
                  class="badges rounded-pill fs-6"
                >
                  <i
                    *ngIf="item.responsible == 0"
                    class="fa fa-align-left"
                  ></i>
                  <i
                    *ngIf="item.responsible == 1"
                    class="fa fa-book"
                  >
                  </i>
                  <i
                    *ngIf="item.responsible == 2"
                    class="fa fa-user"
                  ></i>
                  <i
                    *ngIf="item.responsible == 3"
                    class="fa fa-file"
                  >
                  </i>
                  <i
                    *ngIf="item.responsible == 4"
                    class="fa fa-cog"
                  >
                  </i></span>
              </td>
              <td class="text-center">{{item.assignation_status}}</td>
              <td class="text-center">
                {{item.start_date}}
              </td>
              <td class="text-center">{{item.end_date}}</td>
              <td class="text-center"> 

                <div ngbDropdown class="d-inline-block">
                  <i class="fa-solid fa-gear fa-xl" id="dropdownBasic1" ngbDropdownToggle></i>
                  <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                    <button [routerLink]="['./../create',item.id,'1']" ngbDropdownItem>Continuar</button>
                    <button ngbDropdownItem (click)="stageDelete(item.id)" >Eliminar</button>
                  </div>
                </div>
              </td>
   
            </tbody>
          </ng-container>
            </table>

          </div>
        </div>
  </section>
